/* eslint-disable max-len */
import React from 'react';

interface Props {
  color?: string;
}

export default function SchoolIcon({ color = '#047A9C' }: Props) {
  return (
    <path
      d="M23.37,28.28V0H1.92V28.28H0v2.21H25.29V28.28ZM7.73,4h2.95V7H7.73Zm0,5.19h2.95v3H7.73Zm0,5.2h2.95v3H7.73Zm6.88,12.79H10.68v-6h3.93Zm2.95-9.84H14.61v-3h2.95Zm0-5.2H14.61v-3h2.95Zm0-5.2H14.61V4h2.95Z"
      fill={color}
    />
  );
}
